import axios from 'axios'

const LOCAL_PRINT_SERVICE_URL = 'http://localhost:41000'

class AnapathPrinterRestClient {
    getLocalPrinters() {
        return axios.get(LOCAL_PRINT_SERVICE_URL + '/printers').then(response => response.data)
    }

    async getWorkstation() {
        return axios.get(LOCAL_PRINT_SERVICE_URL + '/workstation').then(response => response.data)
    }

    async getPrintServiceStatus() {
        return fetch(LOCAL_PRINT_SERVICE_URL + '/status')
    }

    async printLabels(data, device) {
        const deviceSelectedPrinterCode = device.selectedPrinter.code
        return axios.put(
            LOCAL_PRINT_SERVICE_URL + '/printers/' + deviceSelectedPrinterCode + '/printLabels',
            data,
            {
                timeout: 300000, // milliseconds
                headers: {
                    'Content-Type': 'text/plain'
                }
            })
    }

    async printReports(data, device) {
        const deviceSelectedPrinterCode = device.selectedPrinter.code
        return axios.put(
            LOCAL_PRINT_SERVICE_URL + '/printers/' + deviceSelectedPrinterCode + '/print',
            data,
            {
                headers: {
                    'Content-Type': 'text/plain'
                }
            }
        )
    }

    async printCassette(data, device, trayName) {
        const deviceSelectedPrinterCode = device.selectedPrinter.code
        const encodedTrayName = encodeURIComponent(trayName)
        return axios.put(
            LOCAL_PRINT_SERVICE_URL + '/printers/' + deviceSelectedPrinterCode + '/printLabels',
            data,
            {
                params: {
                    trayName: encodedTrayName
                },
                headers: {
                    'Content-Type': 'text/plain'
                }
            })
    }

    async printCassetteForPrintMate(encodedContent, device, fileName) {
        const encodedFilePath = btoa(device.path + '\\' + fileName)
        return axios.put(
            LOCAL_PRINT_SERVICE_URL + '/printers/storeFileInDisk',
            encodedContent,
            {
                params: {
                    encodedFilename: encodedFilePath
                },
                headers: {
                    'Content-Type': 'text/plain'
                }
            })
    }
}

export default new AnapathPrinterRestClient()
